import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/screens/AboutCompany/ui/ContactingUs/ContactingUs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/screens/AboutCompany/ui/MainImage/MainImage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/screens/AboutCompany/ui/OurCompany/OurCompany.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/screens/AboutCompany/ui/WeAreInNumbers/WeAreInNumbers.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/ResponsiveImage/ResponsiveImage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/SectionTitle/SectionTitle.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/screens/AboutCompany/ui/WeUnderstand/WeUnderstand.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/PageHead/PageHead.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AlertModal"] */ "/app/src/widgets/AlertModal/ui/AlertModal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/Feedback/ui/Feedback.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/screens/AboutCompany/ui/AboutCompany.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/app/src/widgets/Feedback/ui/Form/Form.tsx");
